























import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';
import AddressStore, { AddressShowDto } from '@/stores/user/address.store';
import AddressEdit from '@/views/account/user/AddressEdit.vue';
import { ErrorStore } from '@/stores/error.store';
import { Addresses } from '@/util/Addresses';
import { StandardErrors } from '@/util/StandardErrors';
import ErrorKey from '@/util/ErrorKey';

@Component({
  components: {AddressEdit},
})
export default class AddressEditForm extends Vue {
  @Prop({required: true})
  private address!: AddressShowDto;
  private loading = false;
  private userStore = getModule(UserStore, this.$store);
  private addressStore = getModule(AddressStore, this.$store);
  private errorStore = getModule(ErrorStore, this.$store);
  private standardBilling = this.isStandardBillingAddress;
  private standardDelivery = this.isStandardDeliveryAddress;
  private hasAnyAddress = true;

  get isStandardBillingAddress(): boolean {
    if (this.address.address.id === undefined) {
      return false;
    }
    return this.userStore.currentUser?.billingAddress?.id === this.address.address.id;
  }

  get isStandardDeliveryAddress(): boolean {
    if (this.address.address.id === undefined) {
      return false;
    }
    return this.userStore.currentUser?.deliveryAddress?.id === this.address.address.id;
  }

  private async updateStandardAddresses() {
    if (this.address.address.id) {
      if (this.standardBilling && this.userStore.currentUser?.billingAddress?.id !== this.address.address.id) {
        await this.userStore.changeUserDefaultBillingAddress(this.address.address.id);
      }
      if (this.standardDelivery && this.userStore.currentUser?.deliveryAddress?.id !== this.address.address.id) {
        await this.userStore.changeUserDefaultDeliveryAddress(this.address.address.id);
      }
    }
  }

  private setAlternativeNames() {
    if (this.userStore.currentUser) {
      if (!this.address.address.firstName) {
        this.address.address.firstName = this.userStore.currentUser.firstname;
      }
      if (!this.address.address.lastName) {
        this.address.address.lastName = this.userStore.currentUser.lastname;
      }
    } else {
      this.$router.push('/');
    }
  }

  public async mounted() {
    this.hasAnyAddress = this.addressStore.addressList.length > 0;
    if (!this.hasAnyAddress) {
      this.standardBilling = true;
      this.standardDelivery = true;
    }
  }

  private async save() {
    const currentAddress = this.address.address;
    this.loading = true;

    if (!Addresses.checkAddress(currentAddress)) {
      this.errorStore.setError(StandardErrors.of(ErrorKey.WrongAddress));
      this.loading = false;
      return;
    }

    try {
      this.setAlternativeNames();
      let addressResult;
      if (currentAddress.id) {
        addressResult = await this.addressStore.updateAddress(currentAddress);
      } else {
        addressResult = await this.addressStore.addAddress(currentAddress);
      }
      if (addressResult.success) {
        this.address.edit = false;
        this.address.address = addressResult.payload || currentAddress;
        await this.updateStandardAddresses();
      }
    } finally {
      this.loading = false;
    }
  }

  public abort() {
    this.$emit('abort-edit');
  }
}
